import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ConfirmProvider } from './components/ui/ConfirmDialog';

// NOTE: We intentionally don't wrap in <React.StrictMode>. In development
// StrictMode double-invokes effects (mount → unmount → mount), which fires every
// data-fetching useEffect twice on first load. This is dev-only (it's stripped
// from production builds), but it makes the local network tab noisy and can
// double-hit the API, so we opt out to keep dev behavior matching production.
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter>
    <ConfirmProvider>
      <App />
    </ConfirmProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
